import { LOGIN_PATHNAME } from '@/shared/constants/pathnames';


/** Логин, после которого пользователь возвращается к принятию приглашения. */
export const buildInviteLoginPath = (token: string, email?: string | null): string => {
    const search   = email ? `?${ new URLSearchParams({ email }).toString() }` : '';
    const callback = `/invite/${ encodeURIComponent(token) }/${ search }`;

    return `${ LOGIN_PATHNAME }?${ new URLSearchParams({ callbackUrl: callback }).toString() }`;
};
